module.exports = __webpack_public_path__ + "static/media/7.bda02f29.jpg";